import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { AuthCallback } from "./components/AuthCallback";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { AppNavbar } from "./components/AppNavbar";
import Feed from "./pages/Feed";
import Dogs from "./pages/Dogs";
import DogDiary from "./pages/DogDiary";
import Auth from "./pages/Auth";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Iscriviti from "./pages/Iscriviti";
import Inviti from "./pages/Inviti";
import Upload from "./pages/Upload";
import PostDetail from "./pages/PostDetail";
import Moderation from "./pages/Moderation";

const AppRouter = () => {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Feed />} />
      <Route path="/accedi" element={<Auth />} />
      <Route path="/recupera" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/iscriviti" element={<Iscriviti />} />
      <Route
        path="/inviti"
        element={
          <ProtectedRoute adminOnly>
            <Inviti />
          </ProtectedRoute>
        }
      />
      <Route path="/cani" element={<Dogs />} />
      <Route path="/cani/:dogName" element={<DogDiary />} />
      <Route path="/ricordo/:postId" element={<PostDetail />} />
      <Route
        path="/condividi"
        element={
          <ProtectedRoute>
            <Upload />
          </ProtectedRoute>
        }
      />
      <Route
        path="/moderazione"
        element={
          <ProtectedRoute adminOnly>
            <Moderation />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Feed />} />
    </Routes>
  );
};

function App() {
  return (
    <div className="grain min-h-screen bg-[#FBF8F3]">
      <BrowserRouter>
        <AuthProvider>
          <AppNavbar />
          <AppRouter />
          <Toaster position="bottom-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
